import { NgModule } from '@angular/core';
import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { AppModule } from './app.module';
@NgModule({
  imports: [
    AppModule,
    BrowserModule.withServerTransition({ appId: 'appProduct' }),
    BrowserTransferStateModule,
  ],
  bootstrap: [AppComponent],
})
export class AppBrowserModule { }